export var MedicationListStatus;
(function (MedicationListStatus) {
    MedicationListStatus["Draft"] = "draft";
    MedicationListStatus["Published"] = "published";
})(MedicationListStatus || (MedicationListStatus = {}));
export var MedicationListType;
(function (MedicationListType) {
    MedicationListType["ScopeOfPracticeList"] = "scopeOfPracticeList";
    MedicationListType["Formulary"] = "formulary";
    MedicationListType["DefaultList"] = "defaultList";
})(MedicationListType || (MedicationListType = {}));
